export default __webpack_public_path__ + "8475fdee6cdb0db68100b02ad9543bd4.png";